import {Component, Output, EventEmitter} from '@angular/core';
import {SessionService} from '../service/session.service';
import {SvgIconService} from '../service/svg-icon.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent {
  @Output() clickMenuItem = new EventEmitter<any>();
  isOpenRegisterTree = false;
  constructor(public sessionService: SessionService,
              private svgIconService: SvgIconService) {
    this.svgIconService.registerIcons();
  }

  /**
   * 登録関連の表示、非表示をセット
   */
  changeRegisterTree() {
    setTimeout(() => {
      this.isOpenRegisterTree = !this.isOpenRegisterTree;
    }, 200);
  }
}
